import { Backdrop, Box, Button, CircularProgress, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useEffect, useState } from "react";
import { useTheme } from "@emotion/react";
import DriverPaymentService from "../../../services/driverPaymentService";
import { formatPrice } from "../../../utils";

const DeleteDriverPaymentModal = ({ open,
    handleClose,
    setPopupMsg,
    setPopupType,
    setShowPopup,
    driverPayment }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [isLoading, setIsLoading] = useState(false);
    const [deleteError, setDeleteError] = useState({});

    const handleDelete = async () => {
        try {
            setIsLoading(true);
            const data = await DriverPaymentService.delete(driverPayment.id);
            if (data.status === 200) {
                setPopupMsg(data.data.message);
                setPopupType('delete');
                setShowPopup(true);
                handleClose({ isReaload: true });
            }

        } catch (error) {
            console.error("An unexpected error occurred:", error);
            setDeleteError({ general: error.response.data.error });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        setDeleteError({});
    }, [open]);

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isTablet ? '70%' : '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: isMobile ? 1 : 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        {/* title */}
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {t('deleteDriverPayment')}
                        </Typography>
                        <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                    </Box>

                    {/* info text */}
                    <Typography variant="body1" sx={{ mt: 2 }}>
                        {t('deleteDriverPaymentSureMsg')} <span style={{ fontWeight: 'bold' }}>
                            {formatPrice(driverPayment.priceAmount)}
                        </span>
                    </Typography>


                    {deleteError.general && (
                        <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                            {deleteError.general}
                        </Typography>
                    )}

                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        mt: deleteError.general ? 2 : 4
                    }}>
                        {/* cancel */}
                        <Button
                            variant="outlined"
                            color="primary"
                            sx={{ textTransform: 'none', width: 140, height: 40 }}
                            onClick={handleClose}
                        >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p>{t('cancel')}</p>
                                <CloseOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                            </Box>
                        </Button>

                        <Box width={20}></Box>

                        {/* delete */}
                        <Button
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                width: 140,
                                height: 40,
                                backgroundColor: theme.palette.red.bg,
                            }}
                            onClick={handleDelete}

                        >
                            {isLoading ? <CircularProgress color="secondary" size={28} /> :
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <p>{t('delete')}</p>
                                    <DeleteOutlineOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                </Box>
                            }
                        </Button>

                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default DeleteDriverPaymentModal;
